export default {
  optionDescriptionRendererColor: Styles.color.black,
  sectionDescriptionRendererColor: Styles.color.black,
};
